import "./index.scss";
import { getExtraPagesReference } from "helpers/pages";
import {
  getFaqDetailPreview,
  getOthersRelatedByKey,
  getTranslations,
} from "helpers/contenful";
import { logDebug } from "helpers/generic";
import FaqDetail from "pageTemplates/templates/faq/FaqDetail";
import React from "react";

// TODO: check
interface PageTemplateProps {
  page: any;
}

const PageTemplate = ({ page }: PageTemplateProps) => {
  logDebug("Page Faq Detail->", page);
  const { content } = page;

  const {
    id,
    contentful_id,
    node_locale,
    title,
    text,
    infoAppLink,
    infoAppContent,
    infoAppVideo,
    infoAppPreviewVideo,
    infoWebContent,
    infoWebVideo,
    infoWebPreviewVideo,
    faqsTopics,
    pageExtra,
  } = content[0];

  // TODO: testing
  const translations = pageExtra[0]?.settings[0]?.translations ?? [];
  const objTranslation = getTranslations(translations, node_locale);

  const listOtherFaqDetailRelatedInTopics = getOthersRelatedByKey(
    faqsTopics,
    "othersFaqsDetail",
    contentful_id,
  );
  const listOtherFaqDetailRelatedExtraPage = getExtraPagesReference(
    listOtherFaqDetailRelatedInTopics,
  );
  const listOtherFaqDetailRelatedPreview = getFaqDetailPreview(
    listOtherFaqDetailRelatedExtraPage,
  );

  logDebug(
    "listOtherFaqDetailRelatedPreview",
    listOtherFaqDetailRelatedPreview,
  );

  const data = {
    id,
    contentful_id,
    title,
    text: text?.text ?? "",
    infoAppLink,
    infoAppContent: infoAppContent?.infoAppContent ?? "",
    infoAppVideo,
    infoAppPreviewVideo,
    infoWebContent: infoWebContent?.infoWebContent ?? "",
    infoWebVideo,
    infoWebPreviewVideo,
    listOtherFaqDetailRelatedPreview,
    // TODO: FAQ DETAIL PREVIEW - RELATED
    // TODO: FAQ TOPIC PREVIEW - RELATED ?
    // TODO: FAQ CLUSTER PREVIEW - RELATED ?
    translations: objTranslation,
  };

  return <FaqDetail {...data} />;
};

export default PageTemplate;
